import {
  Box,
  Button,
  Pagination,
  Table,
  Tbody,
  Td,
  Tfoot,
  Thead,
  Tr,
  formatDate
} from '@veracity/vui'
import { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'

import { useTableSorting } from '@/hooks'
import { ProjectSimple } from '@/interfaces'
import { orderByKey } from '@/utils'

export const TABLE_PAGE_SIZE = 10

interface Props {
  projects: ProjectSimple[] | undefined
}

export const ProjectsListCollectionTable = ({ projects }: Props) => {
  const [pageIndex, setPageIndex] = useState(1)
  const { sort, handleSortChange } = useTableSorting<ProjectSimple>({
    key: 'name',
    order: 'asc'
  })

  const currentPageIndex =
    projects && projects.length < pageIndex * TABLE_PAGE_SIZE
      ? Math.ceil(projects.length / TABLE_PAGE_SIZE)
      : pageIndex

  const pageData = useMemo(
    () =>
      (projects || [])
        .sort(orderByKey(sort.key, sort.order))
        .slice(
          (currentPageIndex - 1) * TABLE_PAGE_SIZE,
          currentPageIndex * TABLE_PAGE_SIZE
        ),
    [currentPageIndex, projects, sort.key, sort.order]
  )

  return (
    <Table
      onSortChange={handleSortChange}
      sort={sort}
      columns={[
        { field: 'name', title: 'Project name', isSortable: true },
        { field: 'companyName', title: 'Company' },
        { field: 'isoBaName', title: 'ISO', isSortable: true },
        { field: 'createdBy', title: 'Created by', isSortable: true },
        { field: 'createdAt', title: 'Created date', isSortable: true },
        { field: 'id', title: ' ' }
      ]}>
      <Thead bg="white" />
      <Tbody bg="white">
        {pageData.map(project => (
          <Tr key={project.id}>
            <Td>
              <Box display="block" w="25vw" isTruncated>
                {project.name}
              </Box>
            </Td>
            <Td>{project.company}</Td>
            <Td>{project.isoBaName}</Td>
            <Td>{project.createdBy}</Td>
            <Td>{formatDate(project.createdAt, 'DD MM YYYY')}</Td>
            <Td>
              <Link to={`/projects/${project.id}`}>
                <Button variant="tertiaryDark" icon="falArrowRight" />
              </Link>
            </Td>
          </Tr>
        ))}
      </Tbody>
      <Tfoot>
        {!!projects?.length && (
          <Tr>
            <Td colSpan={6}>
              <Pagination
                count={projects?.length || 0}
                onPageChange={setPageIndex}
                page={currentPageIndex}
                pageSize={TABLE_PAGE_SIZE}
              />
            </Td>
          </Tr>
        )}
      </Tfoot>
    </Table>
  )
}
